import React, { Component } from "react";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import { Paper } from "@material-ui/core";

export class TabStrip extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedTab: this.props.selected || 0,
    };
    // this.selectTab = this.selectTab.bind(this);
  }

  selectTab(event, index) {
    this.setState({ selectedTab: index });
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.selected !== prevProps.selected &&
      typeof this.props.selected !== "undefined" &&
      this.props.selected != null
    ) {
      this.setState({ selectedTab: this.props.selected });
    }
  }

  render() {
    var tabs = this.props.tabs || [];
    var style = {};
    if (this.props.suppressBoxShadow) {
      style = { boxShadow: "none" };
    }
    return (
      <div
        className="flex-fill flex-column d-flex"
        style={{ overflowY: "hidden" }}
      >
        <Paper square style={style}>
          <Tabs
            value={this.state.selectedTab}
            indicatorColor="primary"
            textColor="primary"
            onChange={this.selectTab.bind(this)}
          >
            {tabs.map((item, idx) => {
              return <Tab key={idx} label={item.display}></Tab>;
            })}
          </Tabs>
        </Paper>
        {tabs.map((item, idx) => {
          var hidden = idx !== this.state.selectedTab;
          return hidden ? <></> : (
            <div
              style={{ flex: "1 1 auto !important", overflowY: "hidden" }}
              key={idx}
              hidden={hidden}
              className={hidden ? "" : "d-flex flex-column flex-fill"}
            >
              {item.component}
            </div>
          );
        })}
      </div>
    );
  }
}
